module.exports = __webpack_public_path__ + "img/news-6.47ea563d.png";